import type { BaseController } from '@infra/controllers/base.controller';
import type { BusAgentStatusListPayload } from '@main/event-listeners/payloads/bus-agent-list.payload';
import type { SyncAgentStatusUsecase } from './sync-agent-status.usecase';

export type StoreAgentStatusOutput = void;

export class SyncAgentStatusController
  implements BaseController<BusAgentStatusListPayload, StoreAgentStatusOutput>
{
  constructor(private usecase: SyncAgentStatusUsecase) {}

  async handle(
    payload: BusAgentStatusListPayload,
  ): Promise<StoreAgentStatusOutput> {
    // if (payload.searchAgents.items.length > 0) {
    await this.usecase.run(payload);
    //}
  }
}
